import mixpanel from 'mixpanel-browser';

// Configuration (could be moved to environment variables)
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';
const PRODUCTION = true;

// Helper function to conditionally execute Mixpanel actions
const executeMixpanel = (callback: () => void): void => {
  if (PRODUCTION) {
    try {
      callback();
    } catch (error) {
      console.error('Mixpanel error:', error);
    }
  }
};

const MixpanelService = {
  init: (): void => {
    executeMixpanel(() => {
      mixpanel.init(MIXPANEL_TOKEN, { debug: true, track_pageview: false });
    });
  },

  trackEvent: (eventName: string, properties: Record<string, any> = {}): void => {
    executeMixpanel(() => {
      mixpanel.track(eventName, properties);
    });
  },

  identifyUser: (userId: string): void => {
    executeMixpanel(() => {
      mixpanel.identify(userId);
    });
  },

  setUserProperties: (properties: Record<string, any>): void => {
    executeMixpanel(() => {
      mixpanel.people.set(properties);
    });
  },
  alias: (userId: string,currentDistinctId:string): void => {
    executeMixpanel(() => {
      mixpanel.alias(userId,currentDistinctId);
    });
  },

  reset: (): void => {
    executeMixpanel(() => {
      mixpanel.reset();
    });
  },

  getDistinctId: (): string | null => {
    try {
      return mixpanel.get_distinct_id();
    } catch (error) {
      console.error('Mixpanel getDistinctId error:', error);
      return null;
    }
  },

  register: (properties: Record<string, any>): void => {
    executeMixpanel(() => {
      mixpanel.register(properties);
    });
  },
};

export default MixpanelService;